<div class="flex flex-col gap-4 p-5 border rounded-md">
  <h2 class="font-semibold text-4">{{ title }}</h2>
  <!-- FORM -->
  <form class="flex flex-col gap-5" [formGroup]="performanceForm">
    <!-- OBJECTIVE SELECTION -->
    <div class="flex flex-col gap-2">
      <h3 class="text-2 font-medium uppercase">{{ translatePrefix + 'objective-selection' | translate }}</h3>
      <div class="grid grid-cols-3 gap-4">
        <app-user-form-dropdown
          [multiple]="true"
          [label]="translatePrefix + 'user' | translate"
          class="!h-11"
          placeholder="Select"
          formControlName="users"
          optionLabel="fullName"
          userType="permission"></app-user-form-dropdown>

        <app-form-control
          *ngIf="userGroups?.length"
          [control]="performanceForm.get('userGroups')"
          [floatLabel]="true"
          [label]="translatePrefix + 'user-groups' | translate">
          <p-treeSelect
            input
            [filter]="false"
            [options]="userGroups"
            [loading]="isLoading"
            scrollHeight="360px"
            containerStyleClass="w-full"
            formControlName="userGroups"
            dropdownIcon="icon-wl-arrow-drop-down"
            selectionMode="checkbox">
            <ng-template pTemplate="triggericon">
              <i class="icon-wl-arrow-drop-down text-6 text-neutral-1000 mr-1.5"></i>
            </ng-template>

            <ng-template pTemplate="itemtogglericon" let-implicit>
              <i
                class="text-6 text-neutral-1000"
                [ngClass]="implicit ? 'icon-wl-arrow-drop-down' : 'icon-wl-arrow-drop-right'"></i>
            </ng-template>

            <ng-template let-value pTemplate="value">
              <span>{{ getTreeNodeValue(value) || (translatePrefix + 'all-groups' | translate) }}</span>
            </ng-template>
          </p-treeSelect>
        </app-form-control>
        <!-- </app-form-control> -->
      </div>
    </div>

    <!-- DATE -->
    <div class="flex flex-col gap-2">
      <h3 class="text-2 font-medium uppercase">{{ translatePrefix + 'date' | translate }}</h3>
      <div class="grid grid-cols-3 gap-4">
        <app-custom-calendar
          [isHasAllTime]="true"
          [required]="true"
          [isInput]="true"
          [title]="translatePrefix + 'date' | translate"
          [(datesSelected)]="dates"
          [maxDate]="dateNow"></app-custom-calendar>
      </div>
    </div>
  </form>
  <div class="flex flex-row">
    <app-button
      variant="outline-primary"
      [label]="exportSelectedFieldsText | translate"
      size="sm"
      (click)="isSelectionDialogVisible = true">
    </app-button>
  </div>

  <!-- ACTIONS -->
  <div class="flex items-center gap-2 justify-end">
    @if (usersValue?.length || userGroupsValue?.length || dates.length === 2) {
      <app-button
        variant="ghost-primary"
        [label]="'action.reset' | translate"
        size="sm"
        (onClick)="onReset()"></app-button>
    }

    <app-button
      [label]="translatePrefix + 'run-report' | translate"
      size="sm"
      [disabled]="performanceForm.invalid || dates.length < 2"
      [loading]="isRunning"
      (onClick)="onRunReport()"></app-button>
  </div>
</div>

<app-report-field-selection
  [(visible)]="isSelectionDialogVisible"
  [(data)]="exportSelectedFields"
  [requiredFields]="requiredExportFieldsPerformanceKey"
  [isAllFieldSelected]="isAllExportFieldsSelected"
  (isAllFieldSelectedChange)="toggleAllExportFields($event)">
</app-report-field-selection>